import EmailCard from '@components/partials/emailSignUp/siteCard';
import styles from '@styles/scss/site/list.module.scss';
import { ReviewSiteType } from 'lib/types/item/reviewSiteType';
import { useRouter } from 'next/router';
const languageFiles = (require as any).context('public/locales', false, /\.json$/);

import React from 'react';

import SiteCard from './card';

export default function SiteList({
    categoryData,
    isCategory,
    currentLang
}: {
    categoryData: any;
    isCategory?: boolean;
    currentLang: string;
}): JSX.Element {
    const router = useRouter();
    const currentSite = router.query.site && router.query.site[0];
    const languageFile = languageFiles(`./${currentLang}.json`);
    const title = languageFile.all_best_sites.replace(
        '%CATEGORY_NAME%',
        categoryData.categoryInfo.name
    );

    // This is to ensure that the current review does not display in the list of similar reviews
    const siteListWithoutCurrentSiteReview = categoryData.activeSites
        .filter((site: ReviewSiteType) => site.slug !== currentSite)
        .sort((a: ReviewSiteType, b: ReviewSiteType) =>
            a.slug === currentSite ? 1 : b.slug === currentSite ? -1 : 0
        );

    return (
        <>
            {isCategory && categoryData.categoryInfo.topContent !== '' && (
                <div className={styles.categoryBanner}>{title}</div>
            )}
            <div className={styles.sites}>
                {siteListWithoutCurrentSiteReview.map((site: any, index: number) =>
                    index === siteListWithoutCurrentSiteReview.length - 1 ? (
                        <React.Fragment key={site.name}>
                            <SiteCard
                                site={site}
                                siteIndex={index + 1}
                                categoryName={categoryData.categoryInfo.name}
                                categorySlug={categoryData.categoryInfo.slug}
                                isCategory={isCategory}
                                buttonText={languageFile.visit}
                            />
                        </React.Fragment>
                    ) : (
                        <SiteCard
                            site={site}
                            siteIndex={index + 1}
                            categoryName={categoryData.categoryInfo.name}
                            categorySlug={categoryData.categoryInfo.slug}
                            key={site.name}
                            isCategory={isCategory}
                            buttonText={languageFile.visit}
                        />
                    )
                )}
            </div>
        </>
    );
}
